import { CategoryFull } from "~/types";
import type { CategoryBreadcrumb } from "~/types/category/CategoryBreadcrumb";

export function useCategoryBreadcrumbs(
  categoryRef: MaybeRef<CategoryFull | undefined | null>,
) {
  return computed<CategoryBreadcrumb[]>(() => {
    const category: CategoryFull | undefined | null = unref(categoryRef);

    return [
      ...(category?.breadcrumbs ?? []),
      category
        ? {
            category_uid: category.uid,
            category_name: category.name,
            category_url_path: category.url_path,
            category_level: category.level,
          }
        : undefined,
    ].filter(Boolean) as CategoryBreadcrumb[];
  });
}
